import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box, Paper } from '@mui/material';
import { IconWeather } from '../../../../../../assets/icons/icon-weather';
import { Header } from '../../../../../../components';
import { useInstallationContext } from '../../../../../../context/installation';
import { AnimatedBox } from '../../components/animated-box/animated-box';
import { SunTime } from '../../components/sun-time/sun-time';
import { WeatherStat } from '../../components/weather-stat/weather-stat';
import { getEnergyAdvice, mockWeatherData } from '../../utils/weather';

export const DashboardWeatherWidget: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { selectedInstallationId } = useInstallationContext();

  if (!selectedInstallationId) return null;

  const energyAdvice = getEnergyAdvice(mockWeatherData);

  return (
    <>
      <AnimatedBox marginBottom={6} delay="0.25s" padding={3} backgroundColor="var(--color-element)">
        <Header title={t('weatherWidget.header')} />

        <Box display="flex" alignItems="center" marginBottom={3} maxWidth={600}>
          <IconWeather />
          <Box marginLeft={2} flex={1}>
            <Typography variant="h4" fontWeight="bold" color="var(--color-type-primary)">
              {mockWeatherData.temperature}°C
            </Typography>
            <Typography variant="body1" color="var(--color-type-primary)">
              {t(mockWeatherData.condition)}
            </Typography>
          </Box>
          <Box textAlign="right">
            <SunTime label={t('weatherWidget.sunrise')} time={mockWeatherData.sunrise} />
            <SunTime label={t('weatherWidget.sunset')} time={mockWeatherData.sunset} />
          </Box>
        </Box>

        <Box
          display="grid"
          gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)' }}
          gap={2}
          marginBottom={3}
          maxWidth={600}
        >
          <WeatherStat label={t('weatherWidget.humidity')} value={`${mockWeatherData.humidity}%`} />
          <WeatherStat label={t('weatherWidget.wind')} value={`${mockWeatherData.windSpeed} km/h`} />
          <WeatherStat label={t('weatherWidget.cloudCover')} value={`${mockWeatherData.cloudCover}%`} />
        </Box>

        <Paper
          elevation={1}
          sx={{
            padding: 2,
            borderLeft: `4px solid ${energyAdvice.color}`,
            backgroundColor: 'var(--color-background)',
          }}
        >
          <Box display="flex">
            <Box flex={1}>
              <Typography fontWeight="bold" color={energyAdvice.color} marginBottom={1}>
                {t(`weatherWidget.energyAdvice.${energyAdvice.type}Title`)}
              </Typography>
              <Typography color="var(--color-type-primary)" marginBottom={2}>
                {t(`weatherWidget.energyAdvice.${energyAdvice.type}Description`)}
              </Typography>
              <Typography
                sx={{
                  padding: 1,
                  backgroundColor: 'var(--color-element)',
                  borderRadius: 1,
                  fontStyle: 'italic',
                }}
              >
                {t(`weatherWidget.energyAdvice.${energyAdvice.type}Tip`)}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </AnimatedBox>
    </>
  );
};
